import { moneyFormat } from 'design-system';

// Data Layer
import { GeneralCatalogItem } from 'data-layer-cr/dist/models';

// Models
import CarItem from '../../../../../models/helperTypes/CarItem';
import ModelsCarItem from '../../../../../models/Catalogs/ModelsCarItem';

// Methods
import {
  brandNameForId,
  modelNameForId,
} from '../../../../../functions/catalogueMapMethods';

// Components
import CardQuotation from '../CardQuotation';

const { formatMoney } = moneyFormat;

type Props = {
  car: CarItem;
  brands: GeneralCatalogItem[];
  models: ModelsCarItem[];
};

const CarDetailsCard = ({ car, brands, models }: Props): JSX.Element => (
  <CardQuotation
    title="Datos del auto"
    subTitle={`${brandNameForId(car.brand, brands)} ${modelNameForId(
      car.model.id,
      models,
    )}`}
    defaultDataList={[{ Value: 'Año', Text: car.year.toString() }]}
    defaultFooter={{
      Value: 'Suma asegurada',
      Text: formatMoney(car.value),
    }}
  />
);

export default CarDetailsCard;
